import { render } from "./ReviewPositionEditor.vue?vue&type=template&id=87ec6834&ts=true"
import script from "./ReviewPositionEditor.ts?vue&type=script&lang=ts&external"
export * from "./ReviewPositionEditor.ts?vue&type=script&lang=ts&external"

import "./ReviewPositionEditor.vue?vue&type=style&index=0&id=87ec6834&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__